import { Typography } from 'src/app/components/Elements/Typography';
import type { TypographyVariant } from 'src/app/components/Elements/Typography';

import { CardRowTextContainer } from './styles';

interface CardRowTextProps {
  leftText: string;
  rightText: string;
  leftTextVariant: TypographyVariant;
  leftTextColor?: string;
  rightTextVariant: TypographyVariant;
  rightTextColor?: string;
  data_cy?: string;
  justifyContent?: string;
  noPadding?: boolean;
}

export const CardRowText = ({
  leftText,
  rightText,
  leftTextVariant,
  leftTextColor,
  rightTextVariant,
  rightTextColor,
  data_cy,
  justifyContent = 'space-between',
  noPadding = false,
}: CardRowTextProps) => (
  <CardRowTextContainer justifyContent={justifyContent} data-cy={data_cy} noPadding={noPadding}>
    <Typography variant={leftTextVariant} color={leftTextColor}>
      {leftText}
    </Typography>
    <Typography variant={rightTextVariant} color={rightTextColor}>
      {rightText}
    </Typography>
  </CardRowTextContainer>
);
